import sanitizeHtml, { defaults } from "sanitize-html"
import { marked } from "marked"
import type { IOptions } from "sanitize-html"

const HIGHLIGHT_RE = /^==([^=]+)==/

const markedHighlight: marked.TokenizerAndRendererExtension = {
  name: "highlight",
  level: "inline",

  start (src) {
    return src.indexOf("==")
  },

  tokenizer (src) {
    const match = HIGHLIGHT_RE.exec(src)
    if (match)
      return {
        type: "highlight",
        raw: match[0],
        text: match[1].trim(),
      }
  },

  renderer (token) {
    return `<mark>${token.text}</mark>`
  },
}

const INSERT_RE = /^\+\+([^=]+)\+\+/

const markedInsert: marked.TokenizerAndRendererExtension = {
  name: "insert",
  level: "inline",

  start (src) {
    return src.indexOf("++")
  },

  tokenizer (src) {
    const match = INSERT_RE.exec(src)
    if (match)
      return {
        type: "insert",
        raw: match[0],
        text: match[1].trim(),
      }
  },

  renderer (token) {
    return `<ins>${token.text}</ins>`
  },
}

marked.use({
  extensions: [
    markedHighlight,
    markedInsert,
  ],
})

export function md (
  raw: any,
  sanitizeOpts: Nullable<IOptions> = null,
): string {
  if (!raw)
    return ""

  const cleanHtml = marked(raw, {
    gfm: true,

    sanitizer (html) {
      return sanitizeHtml(html, {
        allowedTags: defaults.allowedTags.concat(["img"]),
        allowedAttributes: {
          ...defaults.allowedAttributes,
          p: ["align"],
          // "*": ["style"],
        },
        ...sanitizeOpts,
      })
    },
  })
  return cleanHtml
}
